import api from '../../apiConfig/apiConfig'
import {Get, Post, Put, Delete} from '../base/baseAjax'

let listCustomer = () => {
    return Get({
        url: api.sem.listCustomer,
    })
}


let productInfo = param => {
    return Post({
        url: api.sem.productInfo,
        bodyParam: param
    })
}
let programmeList = param => {
    return Post({
        url: api.sem.programmeList,
        bodyParam: param
    })
}
let addProgramme = param => {
    return Post({
        url: api.sem.addProgramme,
        bodyParam: param
    })
}

//获取已保存的关键词
let getSavedKeyword = (programmeDetailId) => {
    return Get({
        url: api.sem.getSavedKeyword,
        PathParam: {id: programmeDetailId}
    })
}
// 获取单个关键词图片
let getKeywordImage = (keywordId) => {
    return Get({
        url: api.sem.getKeywordImage,
        PathParam: {id: keywordId},
        config:{
            timeout:60000
        }
    })
}
//获取已保存广告标题
let getAdsTitle = (programmeDetailId) => {
    return Get({
        url: api.sem.getAdsTitle,
        PathParam: {id: programmeDetailId}
    })
}
//获取已保存广告说明
let getAdsIllustrate = (programmeDetailId) => {
    return Get({
        url: api.sem.getAdsIllustrate,
        PathParam: {id: programmeDetailId}
    })
}
// 获取ai生成关键词 历史记录
let getKeywordTemp = (programmeDetailId) => {
    return Get({
        url: api.sem.getKeywordTemp,
        PathParam: {id: programmeDetailId}
    })
}
// 获取ai生成标题 历史记录
let getAdsTitleTemp = (programmeDetailId) => {
    return Get({
        url: api.sem.getAdsTitleTemp,
        PathParam: {id: programmeDetailId}
    })
}
// 获取ai生成描述 历史记录
let getAdsIllustrateTemp = (programmeDetailId) => {
    return Get({
        url: api.sem.getAdsIllustrateTemp,
        PathParam: {id: programmeDetailId}
    })
}

// 第二页 ai生成产品核心关键词
let secondPageKeyword = (param) => {
    return Post({
        url: api.sem.secondPageKeyword,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}
// 第二页 ai生成产品描述
let secondPageDesc = (param) => {
    return Post({
        url: api.sem.secondPageDesc,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}
// 第二页 产品描述AI总结
let descSummarize = (param) => {
    return Post({
        url: api.sem.descSummarize,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}

// 第三页 生成关键词
let aiKeyword = (param) => {
    return Post({
        url: api.sem.aiKeyword,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}

// 第三页 规划师关键词获取
let plannerKeyword = (param) => {
    return Post({
        url: api.sem.plannerKeyword,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}
// 第三页 关键词ai修改
let keywordAiUpdate = (param) => {
    return Post({
        url: api.sem.keywordAiUpdate,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}
// 第三页 广告标题生成
let adsTitle = (param) => {
    return Post({
        url: api.sem.adsTitle,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}

// 第三页 广告标题ai修改
let titleAiUpdate = (param) => {
    return Post({
        url: api.sem.titleAiUpdate,
        bodyParam: param,
        config: {
            timeout: 6000000,
        },
    })
}
// 第三页 生成广告说明
let adsIllustrate = (param) => {
    return Post({
        url: api.sem.adsIllustrate,
        bodyParam: param,
        config: {
            timeout: 300000,
        },
    })
}
// 第三页 AI修改广告说明
let illustrateAiUpdate = (param) => {
    return Post({
        url: api.sem.illustrateAiUpdate,
        bodyParam: param,
        config: {
            timeout: 30000000,
        },
    })
}

// 第三页 单个产品保存API
let addSingleProduct = (param) => {
    return Post({
        url: api.sem.addSingleProduct,
        bodyParam: param,

    })
}

// 第三页 保存关键词
let addKeyword = (param) => {
    return Post({
        url: api.sem.addKeyword,
        bodyParam: param,

    })
}
// 第三页 保存标题
let addAdsTitle = (param) => {
    return Post({
        url: api.sem.addAdsTitle,
        bodyParam: param,

    })
}
// 第三页 清空关键词
let emptyKeyword = (param) => {
    return Post({
        url: api.sem.emptyKeyword,
        bodyParam: param,

    })
}
// 第三页 清空广告标题
let emptyTitle = (param) => {
    return Post({
        url: api.sem.emptyTitle,
        bodyParam: param,

    })
}
// 第三页 清空广告描述
let emptyIllustrate = (param) => {
    return Post({
        url: api.sem.emptyIllustrate,
        bodyParam: param,

    })
}
// 第三页 添加广告描述
let addAdsIllustrate = (param) => {
    return Post({
        url: api.sem.addAdsIllustrate,
        bodyParam: param,
    })
}
// 第三页 关键词填充到方案
let aiAddProductKeyword = (param) => {
    return Post({
        url: api.sem.aiAddProductKeyword,
        bodyParam: param,
    })
}
// 第三页 标题、描述填充到方案
let aiAddProductTitle = (param) => {
    return Post({
        url: api.sem.aiAddProductTitle,
        bodyParam: param,
    })
}


export default {
    listCustomer: listCustomer,
    productInfo,
    programmeList: programmeList,
    addProgramme: addProgramme,
    getSavedKeyword,
    getKeywordTemp,
    secondPageKeyword,
    secondPageDesc,
    descSummarize,
    aiKeyword,
    plannerKeyword,
    addSingleProduct,
    addKeyword,
    emptyKeyword,
    keywordAiUpdate,
    adsTitle,
    emptyTitle,
    titleAiUpdate,
    getAdsTitle,
    addAdsTitle,
    adsIllustrate,
    emptyIllustrate,
    illustrateAiUpdate,
    getAdsIllustrate,
    addAdsIllustrate,
    getKeywordImage,
    aiAddProductKeyword,
    aiAddProductTitle,
    getAdsTitleTemp,
    getAdsIllustrateTemp
}
